import { lazy } from "react";

export const BurgerMenu = lazy(() => import("./BurgerMenu"));
